import { useAuth } from '../../../../context/AuthContext';
import { Alert } from 'react-bootstrap';
import { formatCurrency } from '../../../../utils/formatters';
import { MAX_CARES_GRANTS, MAX_CARES_AMOUNT } from '../../../../constants/constants';
import getProgramYear from '../../../../utils/ProgramYear';

const CaresAlert = ({
  numGrantsApplied,
  appliedGrantsTotal,
  hasActiveDiscount
}) => {
  if (!hasActiveDiscount) return <></>;

  const { isInternalUser } = useAuth();

  const LIMIT_REACHED = numGrantsApplied >= MAX_CARES_GRANTS || appliedGrantsTotal >= MAX_CARES_AMOUNT;
  const remainingCaresGrantAllowed = MAX_CARES_AMOUNT - appliedGrantsTotal;

  const alertHeaderText = () => {
    if (LIMIT_REACHED)
      return `Customer has reached the CARES Grant limit for the ${getProgramYear()} Program Year.`;

    if (numGrantsApplied == 1)
      return `Customer has received ${numGrantsApplied} CARES Grant${numGrantsApplied != 1? 's': ''} for the ${getProgramYear()} Program Year.`;

    if (hasActiveDiscount)
      return `Customer has an active CARES discount.`

  }

  const alertBodyText = () => {
    var bodyText = '';
    if (LIMIT_REACHED) {
      bodyText += `Customer already received ${numGrantsApplied} CARES Grant${numGrantsApplied != 1? 's': ''} totalling ${formatCurrency(appliedGrantsTotal)} within the current program year. `;
      bodyText += 'At this time, you can select “Apply for an exception request." ';
      if (!isInternalUser) bodyText += 'If discount should be changed due to PEV, select "Change existing discount only."';
      return bodyText;
    }

    if (numGrantsApplied == 1)
      bodyText += `Customer received a CARES Grant of ${formatCurrency(appliedGrantsTotal)} within the current program year. The calculation for the new Total AMP Instant Grant Relief Amount will be limited to the remaining Grant allowed: ${formatCurrency(remainingCaresGrantAllowed)}. `;
    // intentional fall through for compound message

    if (hasActiveDiscount)
      bodyText += 'To keep the current discount, select "Apply for grant only”. If self-declaration ';
      if (!isInternalUser) bodyText += 'or PEV ';
      bodyText += 'should be completed, please select “Change existing discount only” or "Change existing discount and apply for grant".';

    return bodyText;
  }

  return (
    <>
      <Alert id="caresAlert" variant="info" className="mb-0">
          <Alert.Heading>{alertHeaderText()}</Alert.Heading>
          <hr />
          <p className="mb-0">{alertBodyText()}</p>
      </Alert>
    </>
  );
};

export default CaresAlert;